import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { postBoardInvitations } from '../requests';
import type { PostBoardInvitationsRequestParams } from '../types';

export const usePostBoardInvitations = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: PostBoardInvitationsRequestParams) =>
      postBoardInvitations(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.boardInvitations],
      });
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.boardUsers],
      });
    },
  });
};
